export const ALERT_TAGS_LOAD_STATE = {
  NONE: 0,
  INITIAL: 1,
  ALL: 2,
}
